import styled from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE } from 'pages/Fields/fields.constants';

export const Bar = styled.div`
  margin: ${em(10)} 0;
  padding: ${em(10)} ${em(12)};
  font-size: ${rem(15)};
  background: ${PALETTE.brandTint};
  border: ${em(1)} solid ${PALETTE.brandBorder};
  border-radius: ${em(6)};
`;

export const Hint = styled.p`
  margin: ${em(6)} 0 ${em(10)};
  font-size: ${rem(14)};
  color: ${PALETTE.muted};
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${em(8)};
  margin-top: ${em(8)};
`;

export const SizeInput = styled.input`
  width: ${em(80)};
  padding: ${em(4)} ${em(6)};
  font-size: ${rem(15)};
  border: ${em(1)} solid ${PALETTE.line};
  border-radius: ${em(4)};
`;

export const Result = styled.div`
  margin-top: ${em(6)};
  color: ${PALETTE.brandDark};
`;

export const ErrorText = styled.div`
  margin-top: ${em(6)};
  color: #b3261e;
`;
